<template>
    <div class="info form-group">
        <span id="asset-file-name" v-if="dataStore.currentOpinion.image.name.length">{{ dataStore.currentOpinion.image.name }}</span>
        <span v-if="dataStore.currentOpinion.image.name.length" :title="language.remove_image" class="remove-image" @click="removeImage"><i class="fas fa-times"></i></span>
    </div>
</template>

<script>

import dataStore from "../../store";

import { updateAnswer } from './../../functions'

export default {

    inject: [ 'language' ],

    data() {
        return {
            dataStore: dataStore,
        }
    },

    methods: {
        removeImage: function() {
            let answer = this.dataStore.currentOpinion;
            answer.image = { name : '', file : null }
            updateAnswer(answer, this.dataStore.currentOpinion.id);
        },
    }
};
</script>

